module.exports = __webpack_public_path__ + "media/images/avocado_cover-6358c4960d9321e94a3011f96d063a39.jpg";